import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import aboutEn from './locales/en/about.json'
import resumeEn from './locales/en/resume.json'
import navEn from './locales/en/nav.json'
import aboutDe from './locales/de/about.json'
import resumeDe from './locales/de/resume.json'
import navDe from './locales/de/nav.json'

const initialLang =
  typeof window !== 'undefined' ? localStorage.getItem('lang') : null

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: { about: aboutEn, resume: resumeEn, nav: navEn } },
    de: { translation: { about: aboutDe, resume: resumeDe, nav: navDe } },
  },
  lng: initialLang || 'en',
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
})

if (typeof window !== 'undefined') {
  i18n.on('languageChanged', (lng) => {
    localStorage.setItem('lang', lng)
  })
}

export default i18n
